import { Component, EventEmitter, inject, OnInit, Output } from '@angular/core';
import { DxButtonComponent, DxLookupComponent } from 'devextreme-angular';
import { Articoli } from 'src/app/models/articoli';
import { ArticoliService } from 'src/app/shared/services/articoli.service';
import { notificaMessaggio } from 'src/app/utils/notifiche-utils';

@Component({
  selector: 'app-popup-scelta-articolo',
  templateUrl: './popup-scelta-articolo.component.html',
  styleUrls: ['./popup-scelta-articolo.component.scss'],
  imports: [DxButtonComponent, DxLookupComponent],
  standalone: true,
})
export class PopupSceltaArticoloComponent implements OnInit {
  private articoliService = inject(ArticoliService);
  @Output() articoloEventEmitter = new EventEmitter<string>();

  listArticoli: Articoli[] = [];

  idArticolo: number;

  ngOnInit(): void {
    this.loadArticoli();
  }

  loadArticoli() {
    this.articoliService.list(true).subscribe({
      next: (res) => {
        this.listArticoli = res;
      }
    });
  }

  onAnnullaArticolo() {
    this.articoloEventEmitter.emit(null);
  }
  onScegliArticolo() {
    const articolo = this.listArticoli.find((x) => x.id == this.idArticolo);
    this.articoloEventEmitter.emit(articolo.codice);
  }

  getArticoloDisplayExpr(item: Articoli) {
    if (!item) {
      return '';
    }
    let s =
      item.codice +
      (item.taglia ? ' - ' + item.taglia : '') +
      ' - ' +
      item.descrizione;
    return s;
  }
}
